import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  HostListener, Output, EventEmitter
} from '@angular/core';
import KeenSlider, {KeenSliderInstance} from "keen-slider"

@Component({
  selector: 'v-product-gallery',
  templateUrl: './product-gallery.component.html',
  styleUrls: [
    '../../../../../../node_modules/keen-slider/keen-slider.css',
    './product-gallery.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductGalleryComponent implements OnInit, AfterViewInit {
  @Input() pictures;
  @Input() title;
  @Output() close: EventEmitter<void> = new EventEmitter();
  @ViewChild("sliderRef") sliderRef: ElementRef<HTMLElement>;
  @Input() currentSlide;
  active = false;
  slider: KeenSliderInstance = null;

  constructor(private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  @HostListener('window:keydown.escape', ['$event'])
  closeEvent(event: KeyboardEvent) {
    this.close.emit();
  }

  @HostListener('window:keydown.arrowright', ['$event'])
  slideRight(event: KeyboardEvent) {
    this.slidePrev()
  }

  @HostListener('window:keydown.arrowleft', ['$event'])
  slideLeft(event: KeyboardEvent) {
    this.slideNext()
  }

  closeGallery() {
    document.body.classList.remove("scroll-y-hide");
    this.close.emit();
  }

  slideTo(index: number) {
    this.slider.moveToIdx(index);
  }

  slideNext() {
    this.slider.next();
  }

  slidePrev() {
    this.slider.prev();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.slider = new KeenSlider(this.sliderRef.nativeElement,
        {
          initial: this.currentSlide,
          loop: true,
          slideChanged: (s) => {
            this.currentSlide = s.track.details.rel;
            this.cd.markForCheck();
          }
        });
      this.cd.markForCheck();
      this.active = true;
      // prevent animation on scroll on mobile
      document.body.classList.add("scroll-y-hide");
    });
  }
}
